// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Box, Container, Flex, Text, Button } from 'yard-utilities/components'

import SvgBox from '@components/helpers/SvgBox'
import ListItem from '@components/v21/common/list-item/ListItem'

// Icons
import { CheckmarkCircle } from 'icons/v21/Icons'

// Images

import Background from '@images/v25/backgrounds/homepage/background-2.png'

// Styles
import styles from './InternationalTripWrapper.module.sass'

const features = [
  'Recibe alertas instantáneas por email cuando aparezcan vuelos baratos',
  'Entérate cuando las aerolíneas publican accidentalmente precios incorrectos',
  'Consigue las mejores ofertas de vuelos en verano, temporada alta y festivos'
]

interface InternationalTripWrapperProps {
  redirectURL?: string
}

const InternationalTripWrapper = ({
  redirectURL = '/v25/es/membership'
}: InternationalTripWrapperProps) => {
  return (
    <section className={styles.section}>
      <div className={styles.imageWrapper}>
        <Image
          src={Background}
          fill
          sizes="(min-width: 1120px) 3000px, 800px"
          placeholder="blur"
          priority
          alt="Sandy Beach"
        />
      </div>
      <Container>
        <Box
          padding={{ sm: [24] }}
          backgroundColor="white"
          borderRadius={{ sm: [16] }}
          shadow="shadows"
        >
          <Text tagName="h2" variant="title-5" spacing={{ sm: 24 }}>
            Programa un viaje internacional este año y consigue hasta un 90% de
            ahorro en tus vuelos.
          </Text>
          <Flex flexDirection="column" rowGap={{ sm: 16 }} spacing={{ sm: 32 }}>
            {features.map((item, i) => (
              <ListItem
                key={i}
                icon={
                  <SvgBox offset={3}>
                    <CheckmarkCircle color="#00B67A" />
                  </SvgBox>
                }
                textSize="body-1"
                fontWeight={400}
                gap={[8]}
                position="flex-start"
              >
                {item}
              </ListItem>
            ))}
          </Flex>

          <Button
            as={Link}
            href={redirectURL}
            variant="yellow"
            transform="uppercase"
            shadow
          >
            Regístrate y ahorra
          </Button>
        </Box>
      </Container>
    </section>
  )
}

export default InternationalTripWrapper
